import { useEffect, useRef, useState } from 'react';
import { usePixiApp } from '../../services/pixiApp/pixiAppProvider';
import SpriteSheetDemoManager from './spriteSheetDemoManager';

export default function SpriteSheetDemoPage() {
    const { app } = usePixiApp();
    const pixiContainerRef = useRef(null);
    const managerRef = useRef(null);

    const [animationSpeed, setAnimationSpeed] = useState(1);
    const [backgroundColor, setBackgroundColor] = useState('#000000');

    useEffect(() => {
        let spriteSheetDemoManager = null;

        const initSpriteSheetDemo = async () => {
            if (!app || !pixiContainerRef.current) return;

            spriteSheetDemoManager = new SpriteSheetDemoManager();
            spriteSheetDemoManager.setAnimationSpeed(animationSpeed);
            managerRef.current = spriteSheetDemoManager;
            spriteSheetDemoManager.attachToPixiApp(app);
            pixiContainerRef.current.appendChild(app.canvas);
        }

        initSpriteSheetDemo();

        return () => {
            if (spriteSheetDemoManager && app) {
                spriteSheetDemoManager.detachFromPixiApp(app);
            }
        }
    }, [app, pixiContainerRef]);

    const handleSpriteSheetChange = (e) => {
        if (!managerRef.current) return;

        const file = e.target.files[0];
        if (file) {
            const blobUrl = URL.createObjectURL(file);
            managerRef.current.setSpriteSheet(blobUrl);
        }
    }

    const handleAnimationJsonChange = (e) => {
        if (!managerRef.current) return;

        const file = e.target.files[0];
        if (file) {
            const blobUrl = URL.createObjectURL(file);
            managerRef.current.setAnimationJson(blobUrl);
        }
    }

    const handleAnimationSpeedChange = (e) => {
        setAnimationSpeed(e.target.value);
        if (managerRef.current) {
            managerRef.current.setAnimationSpeed(e.target.value);
        }
    }

    const handleBackgroundColorChange = (e) => {
        setBackgroundColor(e.target.value);
        if (app) {
            app.renderer.background.color = e.target.value;
        }
    }

    return (
        <div style={{ width: '100dvw', height: '100dvh', display: 'flex', overflow: 'hidden' }}>
            <div>
                <h1>Sprite Sheet Demo</h1>
                <div>image: <input type="file" accept="image/png" onChange={handleSpriteSheetChange} /></div>
                <div>animation json: <input type="file" accept="application/json" onChange={handleAnimationJsonChange} /></div>
                <div>animation speed: <input type="range" min="0" max="3" step="0.01" value={animationSpeed} onChange={handleAnimationSpeedChange} /> <span>{animationSpeed}</span></div>
                <div>background color: <input type="color" value={backgroundColor} onChange={handleBackgroundColorChange} /></div>
            </div>
            <div style={{ flex: 1 }} ref={pixiContainerRef} />
        </div>
    );
}